import { editableAttrs } from "@/cms/previewUtils";
import { useSiteContent } from "@/cms/SiteContentContext";
import { MAPS_DIRECTIONS_URL } from "@/config/maps";

const FloatingSocialButtons = () => {
  const { content } = useSiteContent();
  const floating = content.floatingButtons;

  return (
    <div className="fixed z-[60] flex flex-col gap-3 bottom-5 right-5 sm:bottom-6 sm:right-6 pointer-events-none">
      <a
        href={MAPS_DIRECTIONS_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Yol tarifi al"
        className="pointer-events-auto w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-blue-700 border border-blue-600 text-white hover:bg-blue-600 shadow-lg shadow-black/40 transition-all duration-200"
      >
        <i className="ri-route-line text-xl sm:text-2xl"></i>
      </a>
      <a
        href={floating.instagramUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        className="pointer-events-auto w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-zinc-950 border border-zinc-600 text-zinc-200 hover:text-white hover:border-red-600 shadow-lg shadow-black/40 transition-all duration-200"
        {...editableAttrs("floatingButtons.instagramUrl", "url")}
      >
        <i className="ri-instagram-line text-xl sm:text-2xl"></i>
      </a>
      <a
        href={floating.whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        className="pointer-events-auto w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-green-700 border border-green-600 text-white hover:bg-green-600 shadow-lg shadow-black/40 transition-all duration-200"
        {...editableAttrs("floatingButtons.whatsappUrl", "url")}
      >
        <i className="ri-whatsapp-line text-xl sm:text-2xl"></i>
      </a>
    </div>
  );
};

export default FloatingSocialButtons;
